import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IonButton } from "@ionic/angular/standalone";

/**
 * headerタグ内のion-buttonがあたったbuttonタグ置換用のPatoHeaderButtonComponentコンポーネント
 */
@Component({
  selector: "pato-header-button",
  templateUrl: "pato-header-button.html",
  styleUrls: ["pato-header-button.scss"],
  imports: [IonButton, CommonModule],
})
export class PatoHeaderButtonComponent {
  /**
   * ion-button='bar-button'か否か
   *
   * @description true: <button ion-button='bar-button'>, false: <button ion-button>に変換されます。
   * @see https://github.com/ionic-team/ionic-v3/blob/master/src/components/button/button.ts#L283
   */
  @Input() isBarButton = true;

  /**
   * スタイルシートクラス名
   *
   * @description 単一指定: className="u-pr8", 複数指定: className="u-pr8 u-pr12"
   */
  @Input() className: string;

  /** ionic v4以降のion-buttonと同じInputプロパティ群 */
  @Input() type: "button" | "reset" | "submit" = "button";
  @Input() fill: "clear" | "outline" | "solid" | "default" = "default";
  @Input() size: "small" | "default" = "default";
  @Input() color: string | undefined;
  @Input() expand: "block" | "full" | undefined;
  @Input() shape: "round" | undefined;
  // @Input() slots: 'start' | 'icon-only' | 'end';
  @Input() disabled = false;

  /** クリックイベント伝達用のイベントエミッター */
  @Output() clickEmitter = new EventEmitter<MouseEvent>();

  /**
   * 親コンポーネントにクリックイベントを伝達します。
   *
   * @param event - マウスイベント
   * @returns void
   */
  public emitClickEvent(event: MouseEvent): void {
    this.clickEmitter.emit(event);
  }
}
